/**
 * index.web.ts
 * Web entry point. react-native-web's AppRegistry renders the same root
 * component into the DOM node that web/index.html provides, so Android, iOS
 * and web all boot from one App.tsx.
 */
import { AppRegistry } from 'react-native';
import App from './App';
import appConfig from './app.json';

// `app.json` is a JSON module — only its default export exists on web.
const appName = appConfig.name;

AppRegistry.registerComponent(appName, () => App);

const rootTag = document.getElementById('root');
if (!rootTag) {
  throw new Error('web/index.html must provide a #root element');
}
AppRegistry.runApplication(appName, { rootTag });
